<template>
  <div :class="columnClassName" data-component-type="ticketreservations">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="openlist-transaction-container" v-if="transaction">
      <transition name="fade">
        <div class="openlist-transaction openlist-ticket" v-show="transaction">
          <h3><i class="fa fa-fw fa-shopping-cart"></i> <template v-if="isConfirmedOrder(transaction)">{{ _('Confirmed order') }}</template><template v-else>{{ _('Open order') }}</template> {{ transaction.id }}</h3>
          <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true, 'OrderDetails')" />
          <div>{{ transactionFullDate }}</div>
          <div v-if="transaction.name">{{ transaction.name }}</div>
          <div v-if="transaction.name">{{ transaction.company }}</div>
          <div v-if="transaction.name">{{ transaction.ident }}</div>
          <div v-if="transaction.name">{{ transaction.address }}</div>
          <div v-if="transaction.name">{{ transaction.zip }}</div>
          <div v-if="transaction.name">{{ transaction.city }}</div>
          <div v-if="transaction.name">{{ transaction.country }}</div>
          <div v-if="transaction.name">{{ transaction.phone }}</div>
          <div v-if="transaction.name">{{ transaction.email }}</div>
          <div v-else>{{ _('Johku App') }}</div>
          <h4>{{ $filters.currency(transaction.totalWithDelivery, settings.currency) }}</h4>
          <hr v-if="transaction.notes" />
          <div v-if="transaction.notes">{{ transaction.notes }}</div>
        </div>
      </transition>
      <transition name="fade">
        <div v-show="items" class="receipt-items open-ticket-items">
          <cart-item parent="openticketlist" :readonly="true" :settings="shopSettings(shopId)" :shopId="shopId" :baseDomain="baseDomain" :locale="locale" :currItem="item" v-for="item in items" :key="item.id" leftcolwidth="0" rightcolwidth="12" context="page" v-if="!item?.discount_id" v-on:extractTicket="extractTicket"></cart-item>
        </div>
      </transition>
      <transition name="fade">
        <div class="buttons button-row" v-show="transaction">
          <button class="btn btn-success" v-on:click="processOrder" :disabled="!isProcessOrderEnabled">{{ _('Process order') }}</button>
          <button class="btn btn-default" v-on:click="closeTransaction">{{ _('Close') }}</button>
        </div>
      </transition>
    </div>
    <div class="openlist-container tinylist-container" v-else>
      <transition name="fade">
        <div class="input-group">
          <input type="text" class="form-control" v-on:keyup="search" :placeholder="searchHint" v-model="searchStr" />
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" v-on:click="clearSearch"><i class="fa fa-fw fa-trash"></i></button>
          </span>
        </div>
      </transition>
      <transition name="fade">
        <div class="openlist-items tinylist-items">
          <show-open-ticket-list v-for="(show, index) in transactions" :key="show.id" :shopSettings="shopSettings" :locale="locale" :selectedShow="show" :index="index" :searchStr="searchStr" v-on:ticketsDeleted="loadReservations" v-on:openTransaction="openTransaction" v-on:closeTransaction="closeTransaction"></show-open-ticket-list>
        </div>
      </transition>
    </div>
    <seat-picker ref="seatPicker" :seats="allSeats" :selectedSeats="selectedSeats" :maxSeats="maxSeats" :column="column" :showButtons="true" v-if="showSeatPicker" v-on:confirmSelection="seatSelectionConfirmed" v-on:closeModal="seatSelectionCancelled" v-on:seatSelected="seatSelected" v-on:seatDeselected="seatDeselected"></seat-picker>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import components from '~/lib/components'
import ShowOpenTicketList from '~/components/ShowOpenTicketList'
import CartItem from '~/components/CartItem'
import SeatPicker from '~/components/SeatPicker'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'

export default {
  data () {
    return {
      shows: [],
      show: null,
      transactions: [],
      transaction: null,
      items: null,
      limit: 1,
      start: 0,
      processing: false,
      searchStr: '',
      selectedShow: null,
      purgeClicked: false,
      purgeConfirmed: false,
      purgeTimeout: false,
      showSeatPicker: false,
      selectedSeats: [],
      allSeats: [],
      extractionItem: null,
      maxSeats: 1,
    }
  },
  mixins: [components, constants],
  computed: {
    ...mapGetters(['activeBasket', 'basketIds', 'basketItems']),
    searchHint () {
      return this._('Type to search open orders')
    },
    data () {
      return JSON.parse(this.component.data)
    },
    transactionFullDate () {
      return DateTime.fromSeconds(Number(this.transaction.orderdate), { zone: this.timezone }).toFormat(this.dateFormat) + ' ' + DateTime.fromSeconds(Number(this.transaction.orderdate), { zone: this.timezone }).toFormat(this.timeFormat)
    },
    isProcessOrderEnabled () {
      return !this.processing && !this.locked && this.basketEmpty
    },
    maxShows () {
      return this.shows.length
    },
    purgeText () {
      if (this.purgeClicked && this.purgeConfirmed) {
        return this._('Purging...')
      }
      if (this.purgeClicked && !this.purgeConfirmed) {
        return this._('Confirm')
      }
      return this._('Purge')
    },
    myBasketItems () {
      let basketItems = this.basketItems
      let ret = {}
      for (var shopIdWithIndex in basketItems) {
        if (Object.prototype.hasOwnProperty.call(basketItems, shopIdWithIndex)) {
          let siArr = shopIdWithIndex.split('-')
          let shopId = siArr[0]
          let index = siArr[1]
          if (index == this.activeBasket) {
            ret[shopId] = basketItems[shopIdWithIndex]
          }
        }
      }
      return ret
    },
    basketEmpty () {
      for (var shopId in this.myBasketItems) {
        if (Object.prototype.hasOwnProperty.call(this.myBasketItems, shopId)) {
          let items = this.myBasketItems[shopId]
          if (items && items.length) {
            return false
          }
        }
      }
      return true
    }
  },
  methods: {
    isConfirmedOrder (order) {
      if (order && parseInt(order.confirmed) === this.ORDER_CONFIRMED) {
        return true
      }
      return false
    },
    setActiveComponent (component) {
      this.$emit('setActiveComponent', component)
    },
    openSeatPicker () {
      this.showSeatPicker = true
    },
    closeSeatPicker () {
      this.showSeatPicker = false
    },
    seatSelected (seatId) {
      this.selectedSeats.push(seatId)
    },
    seatDeselected (seatId) {
      let index = this.selectedSeats.indexOf(seatId)
      if (index !== -1) {
        this.selectedSeats.splice(index, 1)
      }
    },
    seatSelectionCancelled () {
      this.selectedSeats = []
      this.closeSeatPicker()
    },
    async seatSelectionConfirmed () {
      this.closeSeatPicker()
      await this.finishExtraction()
      if (this.selectedSeats.length) {
        this.selectedSeats = []
      }
    },
    async extractTicket (item) {
      this.extractionItem = item
      let response = await axios.get(this.baseDomain + this.shopId + '/orders/' + this.transaction.id + '/items/' + item.item_id + '.json' + '?apikey=' + this.apiKey)
      if (response && response.data && response.data.seats) {
        this.maxSeats = parseInt(item.count, 10)
        this.allSeats = response.data.seats
        this.openSeatPicker()
      }
    },
    async finishExtraction () {
      let basketId = this.basketIds ? this.basketIds[this.shopId + '-' + this.activeBasket] : null
      if (!basketId) {
        return
      }
      let data = {
        basket_id: basketId,
        item_id: this.extractionItem.item_id,
        seats: this.selectedSeats.join(','),
        ticketitems: this.extractionItem.id
      }
      await axios.post(this.baseDomain + this.shopId + '/orders/' + this.transaction.id + '/extractor.json?apikey=' + this.apiKey, data)
      this.openTransaction(this.transaction)
    },
    search () {
      this.doSearch(this)
    },
    clearSearch () {
      this.searchStr = ''
      this.search()
    },
    doSearch: debounce (($this) => {
      $this.loadReservations()
    }, 250),
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    loadReservations () {
      this.transactions = []
      let $this = this
      let searchQuery = ''
      if (this.searchStr) {
        searchQuery = '&search=' + encodeURIComponent(this.searchStr)
      }
      axios.get(this.baseDomain + this.shopId + '/groupedorders.json?apikey=' + this.apiKey + searchQuery + '&rnd=' + Math.random() * 10000)
      .then(function (response) {
        $this.transactions = response.data
      })
    },
    openTransaction (transaction) {
      let $this = this
      let billArr = [
        axios.get(this.baseDomain + this.shopId + '/orders/' + transaction.id + '.json?apikey=' + this.apiKey),
        axios.get(this.baseDomain + this.shopId + '/orders/' + transaction.id + '/items.json?apikey=' + this.apiKey)
      ]
      axios.all(billArr)
      .then(axios.spread(function (billResponse, itemResponse) {
        $this.transaction = billResponse.data
        $this.items = itemResponse.data
      }))
    },
    closeTransaction () {
      this.transaction = false
    },
    async processOrder () {
      if (!this.transaction) {
        return
      }
      this.EventBus.$emit('showReceiptComponent', { shopId: this.shopId, index: this.activeBasket })
      await nextTick()
      this.EventBus.$emit('modifyOrder', {
        order: this.transaction
      })
    },
    getComponentItemId () {
      if (this.transaction) {
        return this.transaction.id
      }
      return null
    }
  },
  watch: {
    transaction (newValue, oldValue) {
      if (newValue) {
        this.getComponentLock(false, 'OrderDetails')
      } else {
        if (oldValue && oldValue.id) {
          this.releaseComponentLock(oldValue.id, 'OrderDetails')
        }
      }
    }
  },
  components: {
    CartItem,
    ShowOpenTicketList,
    SeatPicker
  },
  mounted () {
    this.loadReservations()
  }
}

</script>